import React from 'react';
import NwHomeLayout from 'components/Layout/NwHomeLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { ErrorWrapper } from './ErrorsUI';



const Unavailable = () => {
    return (
        <NwHomeLayout>
            <ErrorWrapper>
                <div className="error-wrapper">
                    <h1>Error</h1>
                    <div className="error-content">
                        <div className="error-icon">
                            <FontAwesomeIcon icon={light("display-slash")} />
                        </div>
                        <div className="error-message">Server Unavailable</div>
                    </div>
                </div>
            </ErrorWrapper>
        </NwHomeLayout>
    )
};

export default Unavailable;
